"use client";
import React, { createContext, useContext, useState } from "react";
import { BASE_URL } from "../config/apiconfig";

const ContactContext = createContext();

export const ContactProvider = ({ children }) => {
const [loading, setLoading] = useState(false);

const token =
typeof window !== "undefined"
? localStorage.getItem("token")
: null;

const headers = {
"Content-Type": "application/json",
Authorization: `Bearer ${token}`,
};

/* GET CONTACT */
const getContact = async () => {
setLoading(true);
try {
const res = await fetch(`${BASE_URL}/contact`, {
method: "GET",
headers,
});

  const data = await res.json();
  return data;
} catch (error) {
  return { status: false, message: "Failed to fetch contact details" };
} finally {
  setLoading(false);
}

};

/* UPDATE CONTACT */
const updateContact = async (payload) => {
setLoading(true);
try {
const res = await fetch(`${BASE_URL}/contact`, {
method: "POST",
headers,
body: JSON.stringify(payload),
});


  const data = await res.json();
  return data;
} catch (error) {
  return { status: false, message: "Contact update failed" };
} finally {
  setLoading(false);
}


};

return (
<ContactContext.Provider
value={{
getContact,
updateContact,
loading,
}}
>
{children}
</ContactContext.Provider>
);
};

export const useContact = () => useContext(ContactContext);
